import React from "react";
import { globalPageStyle } from "../../../global/style/globalPageStyle";
import MyNormalText from "../../commons/myNormalText";

function PaymentCancel({ languageState }) {
    return (
        <div style={globalPageStyle.pageBackground}>
            <main style={globalPageStyle.main}>
                <div style={{ ...globalPageStyle.mainSection, textAlign: 'center' }}>
                    <div style={{ fontSize: '64px', marginBottom: '10px' }}>❌</div>
                    <MyNormalText
                        textWithTranslation={'payment.cancel.title'}
                        language={languageState.language}
                        bold={true}
                        fontSize={32}
                    />
                </div>
                <div style={{ ...globalPageStyle.mainSection, textAlign: 'center' }}>
                    <MyNormalText
                        textWithTranslation={'payment.cancel.subtitle'}
                        language={languageState.language}
                        bold={true}
                        fontSize={18}
                    />
                    <br />
                    <MyNormalText
                        textWithTranslation={'payment.cancel.message'}
                        language={languageState.language}
                    />
                </div>
                <div style={{ ...globalPageStyle.mainSection, textAlign: 'center' }}>
                    <MyNormalText
                        textWithTranslation={'payment.cancel.info'}
                        language={languageState.language}
                        fontSize={14}
                    />
                </div>
            </main>
        </div>
    );
}

export default PaymentCancel;
